export const getCurrentUser = () => {
    try {
        return JSON.parse(localStorage.getItem('biathlonhubUser'));
    } catch {
        return null;
    }
};